import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-11448aff"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "policy-bind-scope",
  style: {"width":"calc(100% - 8px)"}
}
const _hoisted_2 = { class: "policy-bind-scope__mode cm-ui-mb10" }
const _hoisted_3 = { class: "policy-bind-scope__group" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "policy-bind-scope__group-head cm-ui-mb8" }, null, -1))
const _hoisted_5 = { style: {"margin":"10px 0 0"} }
const _hoisted_6 = { class: "policy-bind-scope__terminal" }
const _hoisted_7 = { class: "policy-bind-scope__terminal-toolbar" }
const _hoisted_8 = { class: "policy-bind-scope__terminal-actions" }

import { computed, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import CmTable from '@/components/cmTable/index.vue'
import type { TableOpt } from '@/components/cmTable/types'
import GroupEdit from '@/views/dashboard/_components/used-group/group-edit.vue'
import SelectTerminalDrawer from '@/views/dashboard/_components/select-terminal-drawer/select-terminal-drawer.vue'
import { SelectTerminalDrawerService } from '@/views/dashboard/_components/select-terminal-drawer/select-terminal-drawer.service'
import type { PolicyType } from '@/views/dashboard/_enum/policy-type'
import type { ClientItem } from '@/views/dashboard/_type/client-item'


export default /*#__PURE__*/_defineComponent({
  __name: 'policy-bind-scope',
  props: {
    bindMode: { default: 0 },
    groupIds: { default: () => [] },
    deviceIds: { default: () => [] },
    permissionKey: {},
    presetGroupId: {},
    strategyOver: {},
    disabled: { type: Boolean, default: false },
    maxHeight: { default: 180 },
    groupTipPopover: { type: Boolean, default: true },
    systemTypes: { default: () => [1,3] }
  },
  emits: ["update:bindMode", "update:groupIds", "update:deviceIds", "groupUpdate"],
  setup(__props: any, { emit: __emit }) {

const { t, locale } = useI18n()

/** CmTable 必填 v-model，本组件无筛选字段，仅占位 */
const terminalTableForm = reactive<Record<string, unknown>>({})

const terminalTableOpt = computed<TableOpt>(() => {
  void locale.value
  return {
    columns: [
      {
        prop: 'computer_name',
        label: t('listColumns.computerName'),
        type: 'COMPUTER',
        columnOpt: { minWidth: 140 },
      },
      {
        prop: 'user_mark',
        label: t('listColumns.userMark'),
        showOverflow: true,
        columnOpt: { minWidth: 120 },
      },
      {
        prop: 'group_name',
        label: t('listColumns.groupName'),
        columnOpt: { minWidth: 100 },
      },
      {
        prop: 'client_ip',
        label: t('listColumns.ipAddress'),
        type: 'IP',
        columnOpt: { minWidth: 120 },
      },
    ],
    rowKey: 'device_id',
    hiddenPageTool: true,
    disableScrollLoad: true,
    showActionBar: false,
    maxHeight: 300,
  }
})

const props = __props

const emit = __emit

const terminalDrawerVisible = ref(false)
const selectedTerminals = ref<ClientItem[]>([])
const terminalsLoading = ref(false)

const injector = useReflectiveInjector([SelectTerminalDrawerService])
const selectTerminalService = injector.get(SelectTerminalDrawerService)

/** 接口或回填可能给到字符串，统一成数字，避免 el-radio / v-show 严格等于失效 */
const bindModeNum = computed(() => Number(props.bindMode ?? 0))

const bindModeModel = computed({
  get: () => bindModeNum.value,
  set: (v: number | string) => {
    const n = Number(v)
    emit('update:bindMode', n)
    if (n === 0) {
      emit('update:deviceIds', [])
    } else {
      emit('update:groupIds', [])
    }
  },
})

/** 统一为 number，并去掉 NaN，避免 el-tree setCheckedKeys 异常导致勾选无法回写 */
const groupIdsForTree = computed(() =>
  (props.groupIds || [])
    .map((id) => +id)
    .filter((id) => !Number.isNaN(id)),
)

function onGroupIdsInput(v: number[]) {
  emit('update:groupIds', v)
}

function deviceIdSignature(ids: string[] | undefined) {
  if (!ids?.length) return ''
  return [...ids].sort().join('\u0001')
}

/** 与子网编辑一致：根据 device_ids 拉取终端明细用于回显 */
function hydrateTerminalsFromDeviceIds(ids: string[]) {
  if (!ids?.length) {
    selectedTerminals.value = []
    return
  }
  terminalsLoading.value = true
  selectTerminalService
    .getTerminalList({
      device_ids: ids,
      group_id: -1,
      page: 1,
      limit: Math.max(ids.length, 20),
    })
    .then(res => {
      selectedTerminals.value = res.terminal_list || []
    })
    .catch(() => {
      selectedTerminals.value = ids.map(id => ({ device_id: id } as ClientItem))
    })
    .finally(() => {
      terminalsLoading.value = false
    })
}

watch(
  () => ({
    mode: bindModeNum.value,
    sig: deviceIdSignature(props.deviceIds),
  }),
  ({ mode, sig }) => {
    if (mode !== 1) {
      selectedTerminals.value = []
      return
    }
    if (!sig) {
      selectedTerminals.value = []
      return
    }
    const currentSig = deviceIdSignature(
      selectedTerminals.value.map(t => t.device_id).filter(Boolean) as string[],
    )
    if (currentSig === sig && selectedTerminals.value.length > 0) {
      return
    }
    hydrateTerminalsFromDeviceIds(props.deviceIds)
  },
  { immediate: true },
)

function onTerminalConfirm(rows: ClientItem[]) {
  selectedTerminals.value = rows.slice()
  emit(
    'update:deviceIds',
    rows.map(r => r.device_id).filter(Boolean) as string[],
  )
}

function removeTerminal(deviceId: string) {
  if (!deviceId || props.disabled) return
  selectedTerminals.value = selectedTerminals.value.filter(t => t.device_id !== deviceId)
  emit(
    'update:deviceIds',
    selectedTerminals.value.map(t => t.device_id).filter(Boolean) as string[],
  )
}

function clearTerminals() {
  if (props.disabled) return
  selectedTerminals.value = []
  emit('update:deviceIds', [])
}


return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_radio_group, {
          modelValue: bindModeModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bindModeModel).value = $event)),
          disabled: _ctx.disabled
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio, { label: 0 }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('policyBindScope.groupMode')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio, {
              label: 1,
              style: {"margin-left":"15px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('policyBindScope.terminalMode')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "disabled"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(GroupEdit, {
          "model-value": groupIdsForTree.value,
          "max-height": _ctx.maxHeight,
          "preset-group-id": _ctx.presetGroupId,
          "permission-key": _ctx.permissionKey,
          "strategy-over": _ctx.strategyOver ?? {},
          disabled: _ctx.disabled,
          "show-group-tip-popover": _ctx.groupTipPopover,
          "onUpdate:modelValue": onGroupIdsInput,
          onUpdate: _cache[1] || (_cache[1] = ($event: any) => (emit('groupUpdate')))
        }, {
          groupTipPopover: _withCtx(() => [
            _renderSlot(_ctx.$slots, "group-tip", {}, () => [
              _createElementVNode("strong", null, _toDisplayString(_ctx.$t('policyBindScope.groupTipTitle')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('policyBindScope.groupTipLine1')), 1)
            ])
          ]),
          _: 3
        }, 8, ["model-value", "max-height", "preset-group-id", "permission-key", "strategy-over", "disabled", "show-group-tip-popover"])
      ], 512), [
        [_vShow, bindModeNum.value === 0]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              disabled: _ctx.disabled,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (terminalDrawerVisible.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('policyBindScope.selectTerminals')), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_el_tag, {
              size: "small",
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('policyBindScope.selectedTerminalCount', {
            n:
              selectedTerminals.value.length })), 1)
              ]),
              _: 1
            })
          ]),
          (selectedTerminals.value.length > 0)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                size: "small",
                disabled: _ctx.disabled,
                onClick: clearTerminals
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('editSubnet.clear')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(CmTable, {
          modelValue: terminalTableForm,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((terminalTableForm) = $event)),
          class: "policy-bind-scope__terminal-table cm-ui-mt15",
          data: selectedTerminals.value,
          "table-opt": terminalTableOpt.value,
          "first-loading": false
        }, {
          action: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('listColumns.operation'),
              width: "80",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  class: "cm-link-danger",
                  size: "small",
                  disabled: _ctx.disabled,
                  onClick: ($event: any) => (removeTerminal(row.device_id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('editSubnet.remove')), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue", "data", "table-opt"])
      ])), [
        [_vShow, bindModeNum.value === 1],
        [_directive_loading, terminalsLoading.value]
      ])
    ]),
    _createVNode(SelectTerminalDrawer, {
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      "system-types": _ctx.systemTypes,
      "permission-key": _ctx.permissionKey,
      "strategy-over": _ctx.strategyOver ?? {},
      "prop-selected-data": selectedTerminals.value,
      onConfirm: onTerminalConfirm
    }, null, 8, ["modelValue", "system-types", "permission-key", "strategy-over", "prop-selected-data"])
  ], 64))
}
}

})